<template>
    <div>
        <div v-if="dataFetch" class="container-fluid">
            <div class="d-flex align-items-center pt-5 mb-3">
                <p>Loading...</p>
            </div>
        </div>
        <div v-if="!dataFetch" class="container-fluid">
            <div class="d-flex align-items-center pt-5 mb-3">
                <router-link :to="{ name : 'rationalization'}" class="btn btn-white-naked btn-icon me-3">
                    <i class="fa-solid fa-arrow-left"></i>
                </router-link>
                <div class="d-block display-tektur h2 m-0">
                    {{ dataRationalization.graduation_status == 0 ? 'Tambah':'' }} Data Rasionalisasi
                    {{ dataRationalization.graduation_status == 1 ? ' - '+dataRationalization.users.fullname:'' }}
                </div>
            </div>

            <ul class="nav nav-tabs" v-if="dataRationalization.graduation_status == 0">
                <li class="nav-item" v-for="(item, index) in dataStep" :key="index">
                    <a class="nav-link" :class="tabActive == item.code ? 'active':''" href="javascript:void(0)" id="tab_biodata" v-on:click="changeTab(item.code, item.status)">Langkah {{ ++index }}</a>
                </li>
            </ul>

            <keep-alive>
                <component v-bind:is="currentTabComponent"></component>
            </keep-alive>
        </div>
    </div>
</template>

<script>
import biodataTab from './component/biodata.vue'
import achievementTab from './component/achievement.vue'
import scoreTab from './component/score.vue'
import evaluationTab from './component/evaluation.vue'

export default {
    name: 'RationalizationForm',
    metaInfo: {
        title: 'Formulir Rasionalisasi',
        titleTemplate: '%s - Rasionalisasi Rapor'
    },
    data() {
        return {
            emptyState          : false,
            dataFetch           : false,
            dataStep            : [],
            dataDetail          : [],
            dataRationalization     : {
                users : {
                    account_type : 'free',
                    allow_change_major : 1
                }
            },
            tabActive           : 'biodata',
            currentTabComponent : 'biodata',
            code                : '',

        }
    },
    created() {        
        this.getStep();
        const tabs = ["biodata", "achievement", "score", "evaluation"];

        if(tabs.includes(this.$route.query.active)) {
            this.tabActive = this.$route.query.active;
        }

        if(this.$route.params.code) {
            this.getDataByCode(this.$route.params.code);
        }

        this.changeTab(this.tabActive);
    },
    methods: {
        changeTab: function(params="", status="open") {
            if(status == 'open') {
                this.tabActive = params
                switch (params) {
                    case 'biodata':
                        this.currentTabComponent = biodataTab;
                        break;
                    case 'achievement':
                        this.currentTabComponent = achievementTab;
                        break;
                    case 'score':
                        this.currentTabComponent = scoreTab;
                        break;
                    case 'evaluation':
                        this.currentTabComponent = evaluationTab;
                        break;
                    default:
                        this.$swal({
                            icon: 'warning',
                            title: 'Ups!',
                            text: "Terjadi kesalahan",
                        });
                        this.tabActive = "";
                        break;
                }
            }
        },
        getStep: function() {
            let code = "";

            if ((this.$route.params.code !== undefined) && (this.$route.params.code !== null) && (this.$route.params.code !== "")) {            
                code = this.$route.params.code;
            }
            let uri         = process.env.VUE_APP_APIHOST+'rationalization/step';
            this.$http.get(uri, {
                params : {
                    code : code
                }
            }).then(res => {
                this.dataStep = res.data.data;

                if(res.data.next_step.length > 0) {
                    this.changeTab(res.data.next_step[0].code)
                }
            });
        },
        getDataByCode: function(code) {
            this.dataFetch  = true;
            let uri         = process.env.VUE_APP_APIHOST+'rationalization/detail';

            this.$http.get(uri,{
                params : {
                    code    : code
                }
            }).then(res => {
                if(res.data.status) {
                    this.dataFetch           = false;
                    this.dataRationalization = res.data.data;
                } else {
                    this.$swal({
                        icon: 'warning',
                        title: 'Ups!',
                        text: 'Data tidak ditemukan!',
                        confirmButtonText: 'OK'
                    }).then((result) => {
                        if (result.value) {
                            this.$router.push({
                                name : 'rationalization'                                
                            });
                        }
                    });                    
                }
            });
        },
    }
}
</script>